// AnchorNode: <span data-type="anchor" id="name"></span>
//
// 名前付きアンカー (不可視ターゲット)。同一/他ページから #name で参照できる。
// 編集画面では ⚓name のチップで可視化、エクスポートは空 span[data-type=anchor][id]。
// inline の DecoratorNode。

import { DecoratorNode } from "lexical"

export class AnchorNode extends DecoratorNode {
  static getType() { return "anchor" }

  static clone(node) { return new AnchorNode(node.__name, node.__key) }

  constructor(name = "", key) {
    super(key)
    this.__name = name || ""
  }

  getName() { return this.getLatest().__name }

  isInline() { return true }
  isKeyboardSelectable() { return true }

  createDOM(_config) {
    const span = document.createElement("span")
    span.setAttribute("data-type", "anchor")
    if (this.__name) span.setAttribute("id", this.__name)
    span.setAttribute("data-lexical-anchor", "")
    span.contentEditable = "false"
    span.className = "akebono-anchor-chip"
    span.textContent = `⚓${this.__name}`
    span.title = `アンカー: #${this.__name}`
    return span
  }

  updateDOM(prev, span) {
    if (prev.__name !== this.__name) {
      if (this.__name) span.setAttribute("id", this.__name)
      else span.removeAttribute("id")
      span.textContent = `⚓${this.__name}`
    }
    return false
  }

  decorate(_editor, _config) { return null }

  static importDOM() {
    return {
      span: (node) => {
        if (node.getAttribute("data-type") !== "anchor") return null
        return {
          conversion: (el) => ({ node: $createAnchorNode(el.getAttribute("id") || "") }),
          priority: 2,
        }
      },
    }
  }

  exportDOM() {
    const span = document.createElement("span")
    span.setAttribute("data-type", "anchor")
    if (this.__name) span.setAttribute("id", this.__name)
    return { element: span }
  }

  static importJSON(s) { return $createAnchorNode(s.name) }
  exportJSON() {
    return { type: "anchor", name: this.__name, version: 1 }
  }
}

export function $createAnchorNode(name = "") {
  return new AnchorNode(name)
}

export function $isAnchorNode(node) {
  return node instanceof AnchorNode
}
